import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/user/logo.png'
import _imports_1 from '@/assets/images/user/close.png'


const _withScopeId = n => (_pushScopeId("data-v-dbf97efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mask"
}
const _hoisted_2 = { class: "dialog" }
const _hoisted_3 = { id: "captcha" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: "",
    srcset: ""
  })
], -1))
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "tab" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "code" }
const _hoisted_9 = { class: "phone" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+86", -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "agreement" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "qr" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "codeBorder" }, [
  /*#__PURE__*/_createElementVNode("div", {
    id: "QRcodeBox",
    class: "wrap-canvas"
  })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请使用微信扫码登录", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

import { onMounted, ref, computed, toRefs, watch } from 'vue'
import { useStore } from 'vuex'
import QRCode from 'qrcode'
import selectIcon from '@/assets/images/user/select.png'
import noSelectIcon from '@/assets/images/user/no-select.png'
import useCountDown from '@/utils/useCountDown'
import { ElMessage } from 'element-plus'
import { createUrl } from '@/utils/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'userLogin',
  setup(__props) {

const store = useStore()
// state方法
const loginState = computed(() => store.state.login)
const {
  showLogin,
  activeTab,
  phone,
  smsCode,
  agreement,
  codeSend,
  codeLoading,
  transferCodeInfo,
  userInfo,
  codeError
} = toRefs(loginState.value)
const isReserveShowVip = computed(() => store.state.vip.isReserveShowVip)
const userState = computed(() => store.state.user)

// getter
const isPhone = computed(() => store.getters.isPhone)
const canLogin = computed(() => store.getters.canLogin)

const url = ref(window.location.origin + window.location.pathname)

const qrcode = ref(null)
const countDown = useCountDown({
  time: 59000,
  onFinish: () => {
    store.commit('changeCodeSend', false)
  },
  interval: 1000
})
const times = ref(countDown.current)

const generateQRCode = () => {
  //  0 生产 1体验 2预览
  const map = { 0: 'prod', 1: 'test', 2: 'dev' }
  const url = 'https://static0.xesimg.com/ibook/h5_store/weixin'
  const data = {
    env: map[process.env.VUE_APP_MP_TYPE],
    transfer_code: 'Tal6tj99sfd42nyp01i1usan',
    scene: 1
  }
  QRCode.toCanvas(
    qrcode.value,
    createUrl(url, data),
    {
      width: 224,
      height: 224,
      colorDark: '#000000',
      colorLight: '#ffffff'
    },
    function (error) {
      if (error) console.error(error)
    }
  )
}

const changeTab = (tab: number) => {
  store.commit('changeTab', tab)
  // if (tab === 2 && !transferCodeInfo.value?.transfer_code) {
  // store.dispatch('getTransferCode')
  if (tab === 2) {
    // 生成二维码
    store.dispatch('loginQrcode', '#QRcodeBox')
  } else {
    // 取消二维码轮训
    store.dispatch('cancelQrcode', '#QRcodeBox')
  }
}

const refreshQrcode = () => {
  store.commit('writeTransferInfo', { status: 0 })
  store.dispatch('getTransferCode')
}

const getCode = () => {
  if (isPhone.value && !codeSend.value) {
    if(!userState.value.network){
      return ElMessage.error('网络连接失败，请检查网络连接情况')
    } 
    store.dispatch('getCode', phone.value)
  }
}
const onLogin = () => {
  if (canLogin.value) {
    if (!agreement.value) {
      return ElMessage.info('请勾选同意下方协议')
    }
    if(!userState.value.network){
      return ElMessage.error('网络连接失败，请检查网络连接情况')
    } 
    store.dispatch('login').catch((err) => {
      if (err.errcode === 11037) {
        store.commit('changeCodeError', true)
        return
      }
      ElMessage.error(err.errmsg || '网络连接失败，请检查网络连接情况')
    })
  }
}

const onClose = () => {
  store.dispatch('closeLogin')
  if (window.sessionStorage.getItem('isReserveShowVip') === 'true') {
    const xesTrackVipInfo = JSON.parse(window.sessionStorage.getItem('xesTrackVipInfo') || '{}') || {};
    store.dispatch('openVipDialog', xesTrackVipInfo)
    window.sessionStorage.setItem('isReserveShowVip', 'false')
    window.sessionStorage.removeItem('isDirectPay');
    window.sessionStorage.removeItem('directPayInfo');
  }
}

watch(
  () => codeSend.value,
  (val) => {
    if (val) {
      // 倒计时
      countDown.start()
    }
  }
)
watch(
  () => showLogin.value,
  (val) => {
    if (!val) {
      console.log('重置倒计时')
      // 倒计时
      countDown.reset()
    }
  }
)
// watch(
//   () => transferCodeInfo.value?.status,
//   (status) => {
//     if (status === 1) {
//       generateQRCode()
//     }
//   }
// )
// 订阅vuex action
// store.subscribeAction({
//   after: (action) => {
//     if (action.type === 'codeLogin') {
//       window.location.reload();
//     }
//   }
// })

onMounted(async () => {
  store.dispatch('user/init')
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(showLogin))
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
            [_vShow, _unref(activeTab) === 1]
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", { class: "close" }, [
              _createElementVNode("img", {
                onClick: onClose,
                src: _imports_1,
                alt: "",
                srcset: ""
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab(1))),
                class: _normalizeClass([_unref(activeTab) === 1 && 'tab-active'])
              }, "验证码登录", 2),
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab(2))),
                class: _normalizeClass([_unref(activeTab) === 2 && 'tab-active'])
              }, "扫码登录", 2)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(phone) ? (phone).value = $event : null)),
                    disabled: _unref(codeSend),
                    maxlength: "11",
                    placeholder: "请输入手机号"
                  }, null, 8, _hoisted_11), [
                    [_vModelText, _unref(phone)]
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["sms", [_unref(codeError) && 'code-error']])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(smsCode) ? (smsCode).value = $event : null)),
                    maxlength: "6",
                    placeholder: "请输入验证码"
                  }, null, 512), [
                    [_vModelText, _unref(smsCode)]
                  ]),
                  _createElementVNode("span", {
                    onClick: getCode,
                    class: _normalizeClass([(!isPhone.value || _unref(codeSend)) && 'sms-disable'])
                  }, _toDisplayString(_unref(codeSend)
                    ? `${times.value.seconds?.toString().padStart(2, '0')}s后重发`
                    : '获取验证码'), 3)
                ], 2),
                _createElementVNode("button", {
                  onClick: onLogin,
                  class: _normalizeClass(["button", [!canLogin.value && 'btn-disable']])
                }, " 登录/注册 ", 2),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", {
                    class: "check-icon",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (agreement.value = !_unref(agreement)))
                  }, [
                    _createElementVNode("img", {
                      src: _unref(agreement) ? _unref(selectIcon) : _unref(noSelectIcon),
                      alt: ""
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("p", null, [
                    _createTextVNode(" 我已阅读并同意 "),
                    _createVNode(_component_router_link, {
                      to: "/agreement?type=1",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("《智能学+服务协议》")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: "/agreement?type=2",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("《用户个人信息保护政策》")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" 的相关内容 ")
                  ])
                ])
              ])), [
                [_vShow, _unref(activeTab) === 1],
                [_directive_loading, _unref(codeLoading)]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_17, 512), [
                [_vShow, _unref(activeTab) === 2]
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})